import React from "react";

function SecuredBy() {
  return (
    <div className="flex gap-2 justify-center items-center">
      <svg
        //   width="800px"
        //   height="800px"
        className="h-7 w-7"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g id="Complete">
          <g id="lock">
            <g>
              <rect
                fill="none"
                height={10}
                rx={2}
                ry={2}
                stroke="#000000"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                width={16}
                x={4}
                y={11}
              />
              <path
                d="M16.5,11V8h0c0-2.8-.5-5-4.5-5S7.5,5.2,7.5,8h0v3"
                fill="none"
                stroke="#000000"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
              />
            </g>
          </g>
        </g>
      </svg>
      <h1 className="text-sm text-gray-700">Secured by LIPIA-ONLINE</h1>
    </div>
  );
}

export default SecuredBy;
